document.addEventListener('DOMContentLoaded', () => {
  const root = document.querySelector('[data-delivery-details]');
  if (!root) return;

  const $ = (id) => document.getElementById(id);

  const els = {
    res: $('clarkes_residential'),
    date: $('delivery_date'),
    slot: $('time_slot'),
    specWrap: $('specific-time-wrap'),
    specTime: $('specific_time'),

    name: $('delivery_contact_name'),
    tel: $('delivery_contact_tel'),
    email: $('tracker_email'),
    hours: $('opening_hours'),
    extDoc: $('external_document_no'),
    instructions: $('delivery_instructions'),

    btn: $('delivery-continue-btn'),
    cutoff: $('cutoff-msg'),
    dateReadable: $('delivery-date-readable'),

    errRes: $('res-error'),
    errDate: $('date-error'),
    errSlot: $('slot-error'),
    errSpec: $('spec-error'),
    errName: $('name-error'),
    errTel: $('tel-error'),
    errEmail: $('email-error'),
    errHours: $('hours-error')
  };

  let hasSubmitted = false;
  const markTouched = (el) => { if (el) el.dataset.touched = '1'; };
  const shouldMark = (el) => hasSubmitted || (el && el.dataset.touched === '1' && String(el.value || '').trim() !== '');

  // Rules from Theme settings > Delivery & VAT (window.GRPDelivery); the
  // fallbacks are the values used before the rules became settings.
  const GRP_DELIVERY = window.GRPDelivery || {};
  const cfgNum = (v, d) => (typeof v === 'number' && Number.isFinite(v) ? v : d);
  const cfgId = (v, d) => (typeof v === 'number' && v > 0 ? v : d);
  const cfgSurcharge = GRP_DELIVERY.surchargeVariants || {};
  const CUTOFF_HOUR = cfgNum(GRP_DELIVERY.cutoffHour, 12);
  const CUTOFF_MINUTE = cfgNum(GRP_DELIVERY.cutoffMinute, 30);
  const CUTOFF_LABEL = (CUTOFF_HOUR % 12 || 12) + ':' + String(CUTOFF_MINUTE).padStart(2, '0') + (CUTOFF_HOUR >= 12 ? ' pm' : ' am');
  const minutesToTime = (m) => String(Math.floor(m / 60)).padStart(2, '0') + ':' + String(m % 60).padStart(2, '0');

  // ---- SURCHARGE VARIANT IDS ----
  const SURCHARGE_VARIANTS = {
    pre10: cfgId(cfgSurcharge.pre10, 45887479316643),
    am: cfgId(cfgSurcharge.am, 45887621693603),
    pm: cfgId(cfgSurcharge.pm, 45887621726371),
    specific: cfgId(cfgSurcharge.specific, 45887621759139)
  };
  const ALL_SURCHARGE_IDS = Object.values(SURCHARGE_VARIANTS);

  const formatDate = (d) => {
    const yyyy = d.getFullYear();
    const mm = String(d.getMonth() + 1).padStart(2, '0');
    const dd = String(d.getDate()).padStart(2, '0');
    return `${yyyy}-${mm}-${dd}`;
  };


  const formatHumanDate = (d, includeYear = true) => {
    if (!(d instanceof Date) || Number.isNaN(d.getTime())) return '';
    return d.toLocaleDateString('en-GB', {
      weekday: 'long',
      day: 'numeric',
      month: 'long',
      ...(includeYear ? { year: 'numeric' } : {})
    });
  };

  const dateFromInputValue = (value) => {
    if (!value) return null;
    const d = new Date(`${value}T00:00:00`);
    return Number.isNaN(d.getTime()) ? null : d;
  };

  const escapeHtml = (value) => String(value || '')
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#039;');

  const shortenCartTitle = (title) => String(title || '')
    .replace(/\s+Roofing Kit\b/gi, '')
    .replace(/\bRoofing Kit\s+/gi, '')
    .replace(/\s{2,}/g, ' ')
    .trim();

  const updateReadableDate = () => {
    if (!els.dateReadable || !els.date) return;
    const selected = dateFromInputValue(els.date.value);
    els.dateReadable.innerHTML = selected
      ? `Selected: <strong>${escapeHtml(formatHumanDate(selected))}</strong>`
      : 'Choose an available weekday.';
  };

  const BANK_HOLIDAYS = new Set(Array.isArray(GRP_DELIVERY.bankHolidays) ? GRP_DELIVERY.bankHolidays : ['2026-08-31']);

  const isWeekend = (d) => {
    const day = d.getDay(); // 0 Sun, 6 Sat
    return day === 0 || day === 6;
  };

  const isBankHoliday = (d) => BANK_HOLIDAYS.has(formatDate(d));
  const isNonWorkingDay = (d) => isWeekend(d) || isBankHoliday(d);

  const isValidEmail = (value) => {
    const v = (value || '').trim();
    if (!v) return false;
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v);
  };

  const isValidPhone = (value) => {
    const v = (value || '').trim();
    if (!v) return false;
    // allow +, spaces, (), hyphens
    if (!/^[0-9+()\s-]+$/.test(v)) return false;
    const digits = v.replace(/\D/g, '');
    return digits.length >= 10 && digits.length <= 15;
  };

  const isValidSpecificTime = (value) => {
    const v = (value || '').trim();
    if (!v) return false;
    // expects HH:MM
    const m = /^([01]\d|2[0-3]):([0-5]\d)$/.exec(v);
    if (!m) return false;
    const mins = parseInt(m[1], 10) * 60 + parseInt(m[2], 10);
    const min = 10 * 60;
    const max = 17 * 60;
    return mins >= min && mins <= max;
  };

  // --- Specific time input mask (HH:MM) ---
  const SPEC_MIN = cfgNum(GRP_DELIVERY.specificFrom, 10 * 60);
  const SPEC_MAX = cfgNum(GRP_DELIVERY.specificTo, 17 * 60);

  const toMinutes = (hhmm) => {
    const m = /^([01]\d|2[0-3]):([0-5]\d)$/.exec((hhmm || '').trim());
    if (!m) return null;
    return parseInt(m[1], 10) * 60 + parseInt(m[2], 10);
  };

  const pad2 = (n) => String(n).padStart(2, '0');

  /**
   * Formats raw digits into HH:MM as user types.
   * - digits "1" -> "1"
   * - digits "10" -> "10"
   * - digits "103" -> "10:3"
   * - digits "1030" -> "10:30"
   */
  const formatDigitsToTime = (digits) => {
    const d = (digits || '').replace(/\D/g, '').slice(0, 4);
    if (d.length <= 2) return d;
    return `${d.slice(0, 2)}:${d.slice(2, 4)}`;
  };

  /**
   * Keeps caret position stable when we re-format the value.
   * We map caret by "number of digits before caret".
   */
  const mapCaretByDigits = (oldValue, oldCaret, newValue) => {
    const digitsBeforeCaret = (oldValue.slice(0, oldCaret).match(/\d/g) || []).length;
    if (digitsBeforeCaret <= 0) return 0;

    let seen = 0;
    for (let i = 0; i < newValue.length; i++) {
      if (/\d/.test(newValue[i])) seen++;
      if (seen >= digitsBeforeCaret) return i + 1;
    }
    return newValue.length;
  };

  const clampSpecificTimeIfNeeded = () => {
    const v = (els.specTime?.value || '').trim();
    if (!v) return;

    // If valid HH:MM but out of range, clamp.
    const mins = toMinutes(v);
    if (mins == null) return;

    if (mins < SPEC_MIN) {
      els.specTime.value = minutesToTime(SPEC_MIN);
      return;
    }
    if (mins > SPEC_MAX) {
      els.specTime.value = minutesToTime(SPEC_MAX);
      return;
    }
  };

  const setupSpecificTimeMask = () => {
    if (!els.specTime) return;

    // IMPORTANT: this mask expects the LIQUID input to be type="text", not type="time".
    // (type="time" has browser segment-edit behaviour that causes the bug you're seeing.)

    els.specTime.setAttribute('inputmode', 'numeric');
    els.specTime.setAttribute('autocomplete', 'off');
    els.specTime.setAttribute('maxlength', '5');

    // If theme ever outputs "10:0" etc, normalize on load (only if it looks like time)
    const initial = (els.specTime.value || '').trim();
    if (/^\d{1,2}:\d{1,2}$/.test(initial)) {
      const parts = initial.split(':');
      els.specTime.value = `${pad2(parts[0])}:${pad2(parts[1])}`.slice(0, 5);
    }

    els.specTime.addEventListener('keydown', (e) => {
      // Make Backspace over ":" feel natural
      if (e.key === 'Backspace') {
        const el = e.currentTarget;
        const pos = el.selectionStart || 0;
        const end = el.selectionEnd || 0;
        if (pos === end && pos > 0 && el.value[pos - 1] === ':') {
          e.preventDefault();
          el.setSelectionRange(pos - 1, pos - 1);
        }
      }
    });

    els.specTime.addEventListener('input', (e) => {
      markTouched(els.specTime);

      const el = e.currentTarget;
      const before = el.value || '';
      const oldCaret = el.selectionStart || 0;

      const digits = before.replace(/\D/g, '');
      const formatted = formatDigitsToTime(digits);

      const newCaret = mapCaretByDigits(before, oldCaret, formatted);

      el.value = formatted;
      el.setSelectionRange(newCaret, newCaret);
    });

    // On blur, if user typed e.g. "10" or "103", we don't auto-complete minutes,
    // we only clamp if it forms a valid HH:MM.
    els.specTime.addEventListener('blur', () => {
      clampSpecificTimeIfNeeded();
    });
  };

  setupSpecificTimeMask();

  const nextBusinessDay = (d) => {
    const out = new Date(d);
    while (isNonWorkingDay(out)) out.setDate(out.getDate() + 1);
    return out;
  };

  const computeMinDeliveryDate = () => {
    const now = new Date();

    const nextWorkingDay = (d) => {
      const x = new Date(d);
      x.setDate(x.getDate() + 1);
      while (isNonWorkingDay(x)) x.setDate(x.getDate() + 1);
      return x;
    };

    const cutoff = new Date(now);
    cutoff.setHours(CUTOFF_HOUR, CUTOFF_MINUTE, 0, 0);

    let dispatchDate;

    if (isNonWorkingDay(now)) {
      // Weekend orders dispatch next working day
      dispatchDate = new Date(now);
      while (isNonWorkingDay(dispatchDate)) dispatchDate.setDate(dispatchDate.getDate() + 1);
    } else if (now >= cutoff) {
      // Missed today's cutoff: dispatch next working day
      dispatchDate = nextWorkingDay(now);
    } else {
      // Before cutoff: dispatch today
      dispatchDate = new Date(now);
    }

    // Delivery is next working day after dispatch
    return nextWorkingDay(dispatchDate);
  };

  const syncDeliveryDateToAvailability = () => {
    if (!els.date) return;

    const minDate = computeMinDeliveryDate();
    const minValue = formatDate(minDate);
    const selected = dateFromInputValue(els.date.value);
    const hasInvalidRestoredValue = !selected || els.date.value < minValue || isNonWorkingDay(selected);

    els.date.min = minValue;

    // Browsers can restore an old native date-field value after DOMContentLoaded.
    // Replace only missing, expired or weekend dates; retain a valid future choice.
    if (hasInvalidRestoredValue) {
      els.date.value = minValue;
    }

    updateReadableDate();
  };

  const setMinDateAndMessage = () => {
    if (!els.date) return;

    const now = new Date();
    const minDate = computeMinDeliveryDate();

    syncDeliveryDateToAvailability();

    if (els.cutoff) {
      const cutoff = new Date(now);
      cutoff.setHours(CUTOFF_HOUR, CUTOFF_MINUTE, 0, 0);

      const isWeekendNow = isWeekend(now);
      const isBankHolidayNow = isBankHoliday(now);
      const afterCutoff = now >= cutoff;
      const supportingCopy = isBankHolidayNow
        ? 'Orders placed on the bank holiday will be dispatched on the next working day.'
        : isWeekendNow
          ? 'Orders placed this weekend will be dispatched on the next working day.'
          : afterCutoff
            ? `You’ve missed today’s ${CUTOFF_LABEL} cut-off. This is the first available working-day delivery.`
            : 'Choose this date or any later available weekday.';

      els.cutoff.style.display = 'flex';
      els.cutoff.innerHTML = `
        <span class="delivery-cutoff__icon" aria-hidden="true">
          <svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <rect x="3" y="5" width="18" height="16" rx="2"></rect>
            <path d="M16 3v4M8 3v4M3 10h18"></path>
            <path d="m9 15 2 2 4-4"></path>
          </svg>
        </span>
        <span class="delivery-cutoff__content">
          <span class="delivery-cutoff__eyebrow">Earliest available delivery</span>
          <strong class="delivery-cutoff__date">${escapeHtml(formatHumanDate(minDate))}</strong>
          <span class="delivery-cutoff__copy">${escapeHtml(supportingCopy)}</span>
        </span>`;
    }
  };

  const clearErrors = () => {
    [els.errRes, els.errDate, els.errSlot, els.errSpec, els.errName, els.errTel, els.errEmail, els.errHours].forEach((e) => {
      if (e) e.textContent = '';
    });

    // Reset field states; validate() will re-apply.
    [els.res, els.date, els.slot, els.specTime, els.name, els.tel, els.email, els.hours].forEach((el) => setFieldState(el, null));
  };

  const setFieldState = (el, state) => {
    if (!el) return;
    el.classList.remove('is-valid', 'is-invalid');
    if (state === 'valid') el.classList.add('is-valid');
    if (state === 'invalid') el.classList.add('is-invalid');
  };

  const isSpecificTimeSlot = (slot) => String(slot || '').toLowerCase().startsWith('specific time');

  const updateSelectedSlotUI = () => {
    const radios = Array.from(root.querySelectorAll('input[name="time_slot_radio"]'));
    radios.forEach((r) => {
      const label = r.closest('.delivery-option');
      if (!label) return;
      label.classList.toggle('is-selected', !!r.checked);
    });
  };

  const showSpecificTimeIfNeeded = () => {
    if (!els.slot || !els.specWrap) return;
    const needs = isSpecificTimeSlot(els.slot.value);
    els.specWrap.style.display = needs ? 'block' : 'none';

    if (els.specTime) {
      if (needs) {
        els.specTime.setAttribute('required', 'required');
      } else {
        els.specTime.removeAttribute('required');
        els.specTime.value = '';
      }
    }
  };

  const validate = () => {
    clearErrors();
    let ok = true;

    if (els.res && !els.res.value) {
      if (shouldMark(els.res)) setFieldState(els.res, 'invalid');
      ok = false;
      if (shouldMark(els.res) && els.errRes) els.errRes.textContent = 'Please choose a delivery type.';
    }

    if (els.date && !els.date.value) {
      if (shouldMark(els.date)) setFieldState(els.date, 'invalid');
      ok = false;
      if (shouldMark(els.date) && els.errDate) els.errDate.textContent = 'Please select a delivery date.';
    }

    if (els.date && els.date.value) {
      const chosen = new Date(els.date.value + 'T00:00:00');
      if (isNonWorkingDay(chosen)) {
        if (shouldMark(els.date)) setFieldState(els.date, 'invalid');
        ok = false;
        if (shouldMark(els.date) && els.errDate) els.errDate.textContent = 'Delivery is not available on weekends or bank holidays. Please choose a working day.';
      }
      const min = new Date((els.date.min || els.date.value) + 'T00:00:00');
      if (els.date.min && chosen < min) {
        if (shouldMark(els.date)) setFieldState(els.date, 'invalid');
        ok = false;
        if (shouldMark(els.date) && els.errDate) {
          els.errDate.textContent = `Please choose a date on or after ${new Date(els.date.min + 'T00:00:00').toLocaleDateString('en-GB')}.`;
        }
      }
    }

    if (els.slot && !els.slot.value) {
      if (shouldMark(els.slot)) setFieldState(els.slot, 'invalid');
      ok = false;
      if (shouldMark(els.slot) && els.errSlot) els.errSlot.textContent = 'Please choose a delivery time slot.';
    }

    if (els.name && !els.name.value.trim()) {
      if (shouldMark(els.name)) setFieldState(els.name, 'invalid');
      ok = false;
      if (shouldMark(els.name) && els.errName) els.errName.textContent = 'Please enter a contact name.';
    }

    if (els.tel) {
      const v = (els.tel.value || '').trim();
      if (!v) {
        if (shouldMark(els.tel)) setFieldState(els.tel, 'invalid');
        ok = false;
        if (shouldMark(els.tel) && els.errTel) els.errTel.textContent = 'Please enter a contact telephone number.';
      } else if (!isValidPhone(v)) {
        if (shouldMark(els.tel)) setFieldState(els.tel, 'invalid');
        ok = false;
        if (shouldMark(els.tel) && els.errTel) els.errTel.textContent = 'Please enter a valid phone number.';
      }
    }

    if (els.email) {
      const v = (els.email.value || '').trim();
      if (!v) {
        if (shouldMark(els.email)) setFieldState(els.email, 'invalid');
        ok = false;
        if (shouldMark(els.email) && els.errEmail) els.errEmail.textContent = 'Please enter a tracking email address.';
      } else if (!isValidEmail(v)) {
        if (shouldMark(els.email)) setFieldState(els.email, 'invalid');
        ok = false;
        if (shouldMark(els.email) && els.errEmail) els.errEmail.textContent = 'Please enter a valid email address.';
      }
    }

    if (els.hours && !els.hours.value.trim()) {
      if (shouldMark(els.hours)) setFieldState(els.hours, 'invalid');
      ok = false;
      if (shouldMark(els.hours) && els.errHours) els.errHours.textContent = 'Please enter opening hours.';
    }

    if (els.slot && isSpecificTimeSlot(els.slot.value)) {
      if (!els.specTime) {
        ok = false;
      } else {
        const v = (els.specTime.value || '').trim();
        if (!v) {
          if (shouldMark(els.specTime)) setFieldState(els.specTime, 'invalid');
          ok = false;
          if (shouldMark(els.specTime) && els.errSpec) els.errSpec.textContent = 'Please select a specific time between 10:00 and 17:00.';
        } else if (!isValidSpecificTime(v)) {
          if (shouldMark(els.specTime)) setFieldState(els.specTime, 'invalid');
          ok = false;
          if (shouldMark(els.specTime) && els.errSpec) els.errSpec.textContent = 'Time must be between 10:00 and 17:00.';
        }
      }
    }

    // Apply 'valid' states for filled fields with no errors
    if (els.res && els.res.value) if (shouldMark(els.res)) setFieldState(els.res, 'valid');
    if (els.date && els.date.value && (!els.errDate || !els.errDate.textContent)) if (shouldMark(els.date)) setFieldState(els.date, 'valid');
    if (els.slot && els.slot.value) if (shouldMark(els.slot)) setFieldState(els.slot, 'valid');
    if (els.name && els.name.value.trim()) if (shouldMark(els.name)) setFieldState(els.name, 'valid');
    if (els.tel && els.tel.value.trim()) if (shouldMark(els.tel)) setFieldState(els.tel, 'valid');
    if (els.email && els.email.value.trim()) if (shouldMark(els.email)) setFieldState(els.email, 'valid');
    if (els.hours && els.hours.value.trim()) if (shouldMark(els.hours)) setFieldState(els.hours, 'valid');
    if (els.specTime && els.specWrap && els.specWrap.style.display !== 'none') {
      if (els.specTime.value) if (shouldMark(els.specTime)) setFieldState(els.specTime, 'valid');
    }

    if (els.btn) els.btn.disabled = !ok;
    return ok;
  };

  const fetchCart = () => fetch('/cart.js', { credentials: 'same-origin' }).then((r) => r.json());

  const updateCart = (updates) =>
    fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify({ updates }),
    }).then((r) => r.json());

  const moneyGBP = (cents) => {
    const amount = (cents || 0) / 100;
    return new Intl.NumberFormat('en-GB', { style: 'currency', currency: 'GBP' }).format(amount);
  };

  const renderOrderSummarySkeleton = () => {
    const itemsWrap = document.getElementById('order-summary-items');
    const subtotalWrap = document.getElementById('order-summary-subtotal');
    const subtotalExWrap = document.getElementById('order-summary-subtotal-ex');
    if (itemsWrap) itemsWrap.style.opacity = '0.6';
    if (subtotalWrap) subtotalWrap.style.opacity = '0.6';
    if (subtotalExWrap) subtotalExWrap.style.opacity = '0.6';
  };

  const clearOrderSummarySkeleton = () => {
    const itemsWrap = document.getElementById('order-summary-items');
    const subtotalWrap = document.getElementById('order-summary-subtotal');
    const subtotalExWrap = document.getElementById('order-summary-subtotal-ex');
    if (itemsWrap) itemsWrap.style.opacity = '';
    if (subtotalWrap) subtotalWrap.style.opacity = '';
    if (subtotalExWrap) subtotalExWrap.style.opacity = '';
  };

  const renderOrderSummary = (cart) => {
    const itemsWrap = document.getElementById('order-summary-items');
    if (!itemsWrap || !cart) return;

    clearOrderSummarySkeleton();

    itemsWrap.innerHTML = (cart.items || [])
  .filter((item) => !ALL_SURCHARGE_IDS.includes(Number(item.variant_id)))
  .map((item) => {
      const img = item.image
        ? `<img src="${escapeHtml(item.image)}" alt="" width="56" height="56" loading="lazy">`
        : `<div class="order-summary__thumb--placeholder"></div>`;
      const title = escapeHtml(shortenCartTitle(item.product_title));
      const variant = (item.variant_title && item.variant_title !== 'Default Title')
        ? `<span>${escapeHtml(item.variant_title)}</span>`
        : '';
      return `
        <div class="order-summary__item" data-variant-id="${escapeHtml(item.variant_id)}">
          <div class="order-summary__thumb" aria-hidden="true">
            ${img}
            <span class="order-summary__qty" aria-label="Quantity ${item.quantity}">${item.quantity}</span>
          </div>
          <div class="order-summary__details">
            <p class="order-summary__title">${title}</p>
            <div class="order-summary__meta">${variant}<span>Qty ${item.quantity}</span></div>
          </div>
          <div class="order-summary__price"><span data-vat-price data-price-cents="${item.final_line_price}"></span></div>
        </div>`;
    }).join('');

const merchandiseItems = (cart.items || [])
  .filter((item) => !ALL_SURCHARGE_IDS.includes(Number(item.variant_id)));

const merchandiseSubtotal = merchandiseItems.reduce((sum, item) => {
  return sum + Number(item.original_line_price || item.line_price || item.final_line_price || 0);
}, 0);

const merchandiseFinalSubtotal = merchandiseItems.reduce((sum, item) => {
  return sum + Number(item.final_line_price || item.line_price || 0);
}, 0);

const cartDiscount = Number(cart.total_discount || 0);
const merchandiseDiscount = Math.max(0, cartDiscount);

const sub = document.getElementById('order-subtotal');
const disc = document.getElementById('order-discount');
const discountRow = document.getElementById('order-discount-row');
const discountCaption = document.getElementById('order-discount-caption');

if (sub) {
  sub.innerHTML = `<span data-vat-price data-price-cents="${merchandiseSubtotal}"></span>`;
}

if (disc) {
  disc.innerHTML = merchandiseDiscount > 0
    ? `-<span data-vat-price data-price-cents="${merchandiseDiscount}"></span>`
    : '';
}

if (discountRow) {
  discountRow.style.display = merchandiseDiscount > 0 ? '' : 'none';
}

if (discountCaption) {
  discountCaption.textContent = merchandiseDiscount > 0 ? (GRP_DELIVERY.discountNote || '') : '';
}
    // Trigger VAT re-render if vat-global.js is present
    if (window.__VAT && typeof window.__VAT.apply === 'function') {
      window.__VAT.apply();
    }
  };

  const changeLineByKey = (key, quantity) =>
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify({ id: key, quantity })
    }).then((r) => r.json());

  const addVariant = (variantId, quantity = 1) =>
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify({ items: [{ id: variantId, quantity }] })
    }).then((r) => r.json());

  /**
   * Ensure we end up with:
   * - 0 surcharge items if desiredVariantId is null
   * - exactly 1 surcharge item (the desiredVariantId) with quantity 1 otherwise
   *
   * This prevents the “back button adds extra delivery product” issue.
   */
  const syncSurcharge = async (desiredVariantId) => {
    // Goal: at most 2-3 network calls, always end with 0 or 1 surcharge line (qty 1).
    const cart = await fetchCart();

    const presentSurcharges = cart.items
      .filter((it) => ALL_SURCHARGE_IDS.includes(it.variant_id))
      .map((it) => it.variant_id);

    const desiredPresent = desiredVariantId && presentSurcharges.includes(desiredVariantId);

    // Build one update request to remove others and normalize desired to qty 1 if present
    const updates = {};
    for (const vid of presentSurcharges) {
      updates[vid] = desiredVariantId && vid === desiredVariantId ? 1 : 0;
    }

    if (Object.keys(updates).length) {
      const updated = await updateCart(updates);
      // If desired is present, we're done (updated cart returned)
      if (desiredPresent) return updated;
    } else if (!desiredVariantId) {
      // No surcharges present and none desired
      return cart;
    }

    if (!desiredVariantId) {
      // Desired none, we already removed any present lines (or there were none)
      return await fetchCart();
    }

    // Desired surcharge not present -> add it, then re-fetch cart once
    await addVariant(desiredVariantId, 1);
    // Normalize again (defensive) so we never end up with qty > 1
    const finalCart = await fetchCart();
    const finalUpdates = {};
    for (const it of finalCart.items) {
      if (!ALL_SURCHARGE_IDS.includes(it.variant_id)) continue;
      finalUpdates[it.variant_id] = it.variant_id === desiredVariantId ? 1 : 0;
    }
    if (Object.keys(finalUpdates).length) {
      return await updateCart(finalUpdates);
    }
    return finalCart;
  };

  const slotToServiceLevel = (slot) => {
    const normalized = String(slot || '').toLowerCase();
    if (normalized.startsWith('pre 10am')) return 'ND Pre 10';
    if (normalized === 'am' || normalized.startsWith('am ')) return 'ND AM';
    if (normalized === 'pm' || normalized.startsWith('pm ')) return 'ND PM';
    if (normalized.startsWith('specific time')) return 'ND Specific time';
    return 'ND';
  };

  const desiredSurchargeVariantIdForSlot = (slot) => {
    const normalized = String(slot || '').toLowerCase();
    if (normalized.startsWith('pre 10am')) return SURCHARGE_VARIANTS.pre10;
    if (normalized === 'am' || normalized.startsWith('am ')) return SURCHARGE_VARIANTS.am;
    if (normalized === 'pm' || normalized.startsWith('pm ')) return SURCHARGE_VARIANTS.pm;
    if (normalized.startsWith('specific time')) return SURCHARGE_VARIANTS.specific;
    return null; // FREE standard delivery
  };

  const saveAttributes = async () => {
    const attrs = {
      clarkes_residential: els.res?.value || '',
      clarkes_delivery_date: els.date?.value || '',
      clarkes_time_slot: els.slot?.value || '',
      clarkes_specific_time_value: els.specTime?.value || '',
      delivery_contact_name: els.name?.value || '',
      delivery_contact_tel: els.tel?.value || '',
      tracker_email: els.email?.value || '',
      opening_hours: els.hours?.value || '',
      external_document_no: els.extDoc?.value || '',
      delivery_instructions: els.instructions?.value || '',
      clarkes_service_level: slotToServiceLevel(els.slot?.value || '')
    };

    await fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify({ attributes: attrs })
    });
  };

  const splitName = (full) => {
    const s = (full || '').trim().replace(/\s+/g, ' ');
    if (!s) return { first: '', last: '' };
    const parts = s.split(' ');
    return { first: parts.shift() || '', last: parts.join(' ') || '' };
  };

  const buildCheckoutUrl = () => {
    const params = new URLSearchParams();
    // Attempt to prefill checkout fields (may be ignored by Shopify depending on context)
    const email = els.email?.value?.trim();
    if (email) params.set('checkout[email]', email);

    const nm = splitName(els.name?.value);
    if (nm.first) params.set('checkout[shipping_address][first_name]', nm.first);
    if (nm.last) params.set('checkout[shipping_address][last_name]', nm.last);

    const tel = els.tel?.value?.trim();
    if (tel) params.set('checkout[shipping_address][phone]', tel);

    const qs = params.toString();
    return qs ? `/checkout?${qs}` : '/checkout';
  };

  // Events
  setMinDateAndMessage();
  showSpecificTimeIfNeeded();
  validate();

  // Native date inputs can be restored by the browser after DOMContentLoaded
  // (especially after refresh/back navigation). Re-check after restoration so
  // the visible field, helper text and minimum date always agree.
  const resyncDateAfterBrowserRestore = () => {
    syncDeliveryDateToAvailability();
    validate();
  };

  requestAnimationFrame(() => requestAnimationFrame(resyncDateAfterBrowserRestore));
  window.setTimeout(resyncDateAfterBrowserRestore, 150);
  window.setTimeout(resyncDateAfterBrowserRestore, 750);
  window.addEventListener('pageshow', () => window.setTimeout(resyncDateAfterBrowserRestore, 0));

  // Initial order summary (and VAT render)
  fetchCart().then(renderOrderSummary).catch(() => {});

  const handleSlotChange = async () => {
    try {
      showSpecificTimeIfNeeded();
      updateSelectedSlotUI();

      const desiredVariantId = desiredSurchargeVariantIdForSlot(els.slot?.value || '');

      // Optimistically re-render (keeps UI responsive)
      renderOrderSummarySkeleton();

      const cart = await syncSurcharge(desiredVariantId);
      if (cart) renderOrderSummary(cart);
    } catch (e) {
      console.warn('[Delivery Details] Could not refresh order summary:', e);
      try {
        const cart = await fetchCart();
        renderOrderSummary(cart);
      } catch (_) {}
    } finally {
      validate();
    }
  };

  if (els.slot) {
    els.slot.addEventListener('change', handleSlotChange);
  }

  // Time slot radios (styled list)
  const slotRadios = Array.from(root.querySelectorAll('input[name="time_slot_radio"]'));
  if (slotRadios.length) {
    const syncSlotFromRadios = () => {
      const checked = slotRadios.find((r) => r.checked);
      if (checked && els.slot) {
        els.slot.value = checked.value;
      } else if (els.slot) {
        els.slot.value = '';
      }
    };

    // initial sync (for prefills)
    syncSlotFromRadios();
    updateSelectedSlotUI();
    showSpecificTimeIfNeeded();

    slotRadios.forEach((r) => {
      r.addEventListener('change', () => {
        syncSlotFromRadios();
        updateSelectedSlotUI();
        showSpecificTimeIfNeeded();
        markTouched(els.slot);
        handleSlotChange();
        validate();
      });
    });
  }

['change', 'input'].forEach((evt) => {
  ['clarkes_residential', 'delivery_date', 'time_slot', 'delivery_contact_name', 'delivery_contact_tel', 'tracker_email', 'opening_hours'].forEach((id) => {
    const el = $(id);
    if (el) el.addEventListener(evt, () => {
      markTouched(el);
      if (id === 'delivery_date') updateReadableDate();
      showSpecificTimeIfNeeded();
      validate();
    });
  });
});

  if (els.btn) {
    els.btn.addEventListener('click', async (e) => {
      e.preventDefault();
      hasSubmitted = true;
      if (!validate()) return;

      els.btn.disabled = true;
      els.btn.classList.add('is-loading');

      try {
        const desiredVariantId = desiredSurchargeVariantIdForSlot(els.slot?.value || '');
        await syncSurcharge(desiredVariantId);
        await saveAttributes();
        window.location.href = buildCheckoutUrl();
      } catch (err) {
        console.error('[Delivery Details] Failed:', err);
        els.btn.disabled = false;
        alert('Sorry — something went wrong saving your delivery details. Please try again.');
      } finally {
        els.btn.classList.remove('is-loading');
      }
    });
  }
});